import { useEffect, useRef } from 'react'
import { SLowcodeList } from 'shj-components'
import { config } from './config.tsx'
import { getSalesTemplateTaskEnum } from '@/services/customerServices.ts'

export default function FollowUpTask() {
  const listRef = useRef<any>()
  useEffect(() => {
    getList()
  }, [])
  const getList = async () => {}
  const fetchList = async params => {
    let list: any = await getSalesTemplateTaskEnum()
    return new Promise(async (resolve, reject) => {
      try {
       console.log(params.query.taskName);
       
        if (params.query.taskName) {
          list = list.filter(item => item.taskName.includes(params.query.taskName))
        }
        list.forEach((item, index) => {
          item.number = index + 1
        })
        listRef.current?.updateDataSource(list)
        resolve({ records: list, total: list.length })
      } catch (e) {
        reject({ success: false })
      }
    })
  }
  const extensions = {
    request: { fetchList },
    events: {},
    customRender: {},
  }

  return (
    <div>
      <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
    </div>
  )
}
